// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".layout-default[data-v-76c17924]{background-color:#f5f7fd;width:100%;min-width:1200px;height:100%;overflow:auto}.layout-default .page-header[data-v-76c17924]{position:absolute;left:0;width:100%;z-index:999}.layout-default .page-body[data-v-76c17924]{margin-top:74px}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
